import {
  BLOCKS_MINI_APP_URL,
  BLOCKS_PURCHASE_TOMAN,
  BLOCKS_TELEGRAM_CHANNEL,
  BLOCKS_TELEGRAM_MINI_APP_BOT,
} from "../../../config/blocks";
import {
  buildDefaultTransactionFeeTiers,
  DEFAULT_BLOCK_RULES,
  DEFAULT_LOTTERY_RULE,
} from "../../../config/lotteryDefaults";
import lotteryConfig from "../../../../config/lottery.json";
import type { BlocksExperienceSnapshot, BlocksReferralTier } from "./types";

function buildReferralTiers(): BlocksReferralTier[] {
  return [
    {
      label: "سطح اول",
      percent: 10,
      description: "۱۰٪ از جایزه بلاک برای دعوت‌کننده مستقیم محفوظ است.",
    },
    {
      label: "سطح دوم",
      percent: 5,
      description: "۵٪ از جایزه به معرف سطح دوم می‌رسد.",
    },
    {
      label: "سطح سوم",
      percent: 1,
      description: "۱٪ از جایزه برای معرف سطح سوم در نظر گرفته شده است.",
    },
  ];
}

function resolveMiniAppUrl(): string {
  if (BLOCKS_MINI_APP_URL && BLOCKS_MINI_APP_URL.trim().length > 0) {
    return BLOCKS_MINI_APP_URL.trim();
  }
  const normalisedBot = BLOCKS_TELEGRAM_MINI_APP_BOT.replace(/^@/, "");
  return `https://t.me/${normalisedBot}?startapp=ref`;
}

export function buildFallbackBlocksExperienceSnapshot(): BlocksExperienceSnapshot {
  const fallbackReferralCode = ((): string => {
    const raw = (lotteryConfig as any)?.referral?.code;
    if (typeof raw === "string" && raw.trim()) return raw.trim();
    return "8D67647";
  })();
  const fallbackReferralUrl = ((): string => {
    const raw = (lotteryConfig as any)?.referral?.signupUrl;
    if (typeof raw === "string" && raw.trim()) return raw.trim();
    return `https://nobitex.ir/signup/?refcode=${fallbackReferralCode}`;
  })();
  const now = Date.now();
  const lastBlockHeight = 820_000;
  const nextBlockHeight = lastBlockHeight + 1;
  const baseHash = "0000000000000000000000000000000000000000000000000000000000000000";

  return {
    source: "live",
    generatedAt: now,
    inviteStats: {
      invitedTotal: 0,
      invitedDelta24h: 0,
      tradesTotal: 0,
      tradesDelta24h: 0,
    },
    balance: {
      availableToman: 0,
      requiredToman: BLOCKS_PURCHASE_TOMAN,
      pendingTopUpToman: 0,
      lotteryEarningsSats: 0,
      referralEarningsSats: 0,
      withdrawableSats: 0,
      pendingWithdrawalSats: 0,
      lastWithdrawalRequestedAt: null,
      nextWithdrawalEligibleAt: null,
    },
    lastBlock: {
      height: lastBlockHeight,
      hash: baseHash,
      minedAt: now - 3 * 60 * 60 * 1000,
      elapsedMs: 3 * 60 * 60 * 1000,
    },
    nextBlock: {
      height: nextBlockHeight,
      purchaseWindowClosesAt: now + 2 * 60 * 60 * 1000,
      participants: [],
      assignmentNote: "در انتظار دریافت اطلاعات به‌روزرسانی از سرور.",
      headerPreview: baseHash,
      rewardSats: null,
      referralBreakdown: {
        directPercent: 10,
        indirectPercent: 5,
        directSats: null,
        indirectSats: null,
        winnerSats: null,
        level3Percent: 1,
        level3Sats: null,
      },
    },
    blocks: [
      {
        height: lastBlockHeight,
        hash: baseHash,
        headerTail: "0",
        minedAt: now - 3 * 60 * 60 * 1000,
        totalToman: BLOCKS_PURCHASE_TOMAN,
        participantCount: 0,
        registrationCount: 0,
        status: "active",
        rewardToman: null,
        rewardSats: null,
        directReferralSats: null,
        indirectReferralSats: null,
        tertiaryReferralSats: null,
        winnerName: null,
        winnerTicket: null,
        verificationSeed: null,
        primaryPurchaseId: null,
        participants: [],
      },
    ],
    fees: buildDefaultTransactionFeeTiers(),
    lotteryRule: DEFAULT_LOTTERY_RULE,
    admin: null,
    referrals: {
      inviteCode: fallbackReferralCode,
      botInviteLink: resolveMiniAppUrl(),
      siteInviteLink: fallbackReferralUrl,
      shareMessage: `با خرید بلاک و دعوت از دوستان، شانس برنده‌شدن بیت‌کوین داری! لینک دعوت من: ${fallbackReferralUrl}`,
      tiers: buildReferralTiers(),
      totalEarnedSats: 0,
      tree: [],
    },
    miniApp: {
      bot: BLOCKS_TELEGRAM_MINI_APP_BOT,
      url: resolveMiniAppUrl(),
    },
    rules: DEFAULT_BLOCK_RULES,
    rates: null,
    viewer: {
      isLoggedIn: false,
      telegramVerified: false,
      channelMember: null,
    },
    publicEnvironment: {
      purchaseAmountToman: BLOCKS_PURCHASE_TOMAN,
      purchasesActive: true,
      withdrawalMinimumSats: 500,
      withdrawalCooldownHours: 7 * 24,
      telegramChannel: BLOCKS_TELEGRAM_CHANNEL,
    },
  };
}
